import storageSession from 'redux-persist/lib/storage/session';
import { persistStore, persistReducer } from 'redux-persist';

import { configureStore, combineReducers } from '@reduxjs/toolkit';

import  { auth } from './modules/idp/authreducer';
import {company} from './modules/idp/companyreducer';
import {user} from './modules/idp/userreducer';

// ECS Stores
import { ecsData } from './modules/ecs/datareducer';
import { ecsAlert } from './modules/ecs/alertreducer';
import {report} from './modules/ecs/reportreducer';

// RhymScan Stores
import { rsData } from './modules/rhymscan/datareducer';
import { rsAlert } from './modules/rhymscan/alertreducer';
import { rsReport } from './modules/rhymscan/reportreducer';

// VAPT Stores
import { vaptData } from './modules/vapt/datareducer';
import { vaptReport } from './modules/vapt/reportreducer';
import { vaptAlert } from './modules/vapt/alertreducer';
import { socData } from './modules/soc/agentreducer';
// import { capSelfAssessment } from './modules/cap/selfassessmentreducer'; //TE for data persistence //TE for Data Persistence using create slice method commented prev code to replace with following one
import capSelfAssessment from './modules/cap/selfassessmentreducer'; //TE for Data Perssitence using create slice method


//SOC Stores
const persistConfig = {
  key: 'root',
  storage: storageSession,
};

const rootReducer = combineReducers({
  auth,
  company,
  user,
  // ECS stores
  ecsData,
  ecsAlert,
  report,

  // RhymScan Stores
  rsAlert,
  rsData,
  rsReport,

  // VAPT Stores
  vaptData,
  vaptReport,
  vaptAlert,

  // SOC Stores
  socData,
  
  //CAP Self Assessment
  capSelfAssessment,  //TE for data persistence


});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
})

export const persistor = persistStore(store);


export default store;
